import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmSchoolIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmSchoolIcon = ({ className, ...props }: EmSchoolIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.08813 11.4073V21.328H21.0359V11.3695C21.0359 11.3695 17.045 8.61609 16.8611 8.59031C16.6772 8.56453 11.3164 3.6575 11.3164 3.6575L5.40735 8.42359L1.08813 11.4073Z"
      fill="#F8C778"
    />
    <path
      d="M1.08813 11.397H5.79751L5.79235 21.3177H6.57438L6.57954 9.24L11.1995 5.17344L15.8608 9.43594L15.8488 21.3177H16.5809L16.593 11.3403L21.0359 11.3713V10.7783L16.9831 8.60578L11.5622 3.84312L5.57751 8.50781L1.09157 10.8298L1.08813 11.397Z"
      fill="#F5B03F"
    />
    <path
      d="M2.25159 7.31673C2.22065 7.36657 1.02268 10.67 1.00034 10.7388C0.977993 10.8075 1.03471 10.8883 1.17221 10.9003C1.30971 10.9124 6.05174 10.9003 6.05174 10.9003L6.03799 8.87563C6.03799 8.87563 11.1289 4.29344 11.1856 4.29344C11.2424 4.29344 16.3728 8.99423 16.3849 9.06469C16.3969 9.13344 16.4072 10.8213 16.4072 10.8213C16.4072 10.8213 20.9189 10.8556 21.0117 10.8677C21.1046 10.8797 21.1269 10.7525 21.0461 10.5119C20.9653 10.2713 20.0235 7.36657 19.9547 7.32016C19.886 7.27376 16.1666 7.27376 16.1666 7.27376C16.1666 7.27376 11.5071 2.98376 11.4263 2.91501C11.3455 2.84626 11.1049 2.74141 10.8917 2.95454C10.7044 3.14188 6.0569 7.30813 6.0569 7.30813C6.0569 7.30813 2.28596 7.25829 2.25159 7.31673Z"
      fill="#A62714"
    />
    <path
      d="M7.54701 13.8514L7.54529 21.3245H14.8259V13.8514C14.8259 13.8514 7.54701 13.8325 7.54701 13.8514Z"
      fill="#CF6150"
    />
    <path
      d="M0.625559 21.3555C0.689153 21.4517 1.43165 21.407 3.40993 21.4173C5.38822 21.4276 5.964 21.4242 6.06712 21.4036C6.16853 21.383 6.25103 20.9378 6.184 20.5511C6.11009 20.1266 5.85572 19.7261 5.44322 19.5972C4.8915 19.4253 4.55118 19.5834 4.2865 19.4906C4.02181 19.3995 3.24665 19.0111 2.46118 19.0626C1.78743 19.1056 1.3079 19.3033 0.890247 19.9186C0.441653 20.5803 0.584309 21.2936 0.625559 21.3555Z"
      fill="#7DB240"
    />
    <path
      d="M21.6717 21.3142C21.7731 21.2438 21.7646 19.2913 20.4067 19.1417C19.3875 19.03 19.1211 19.4683 18.9492 19.4683C18.7757 19.4683 18.1156 19.1469 17.2047 19.4992C16.0721 19.9375 16.0927 21.2128 16.1339 21.3349C16.1752 21.4569 17.3474 21.426 18.9578 21.4363C20.5683 21.4466 21.5394 21.407 21.6717 21.3142Z"
      fill="#7DB240"
    />
    <path
      d="M1.98865 11.9677H5.20099V14.5544H1.94568C1.94568 14.5544 1.9663 11.9883 1.98865 11.9677Z"
      fill="#3E737C"
    />
    <path
      d="M1.94571 15.7626H5.14431V18.2651H1.91821C1.91821 18.2669 1.93196 15.7489 1.94571 15.7626Z"
      fill="#3E737C"
    />
    <path
      d="M2.47491 12.4403H4.65773V14.1505H2.44741C2.44741 14.1505 2.43194 12.4541 2.47491 12.4403Z"
      fill="#A7D0D7"
    />
    <path
      d="M2.3772 16.1803H4.68548V17.8355H2.3772C2.3772 17.8355 2.3772 16.1666 2.3772 16.1803Z"
      fill="#A7D0D7"
    />
    <path
      d="M17.1307 12.1206H20.3293V14.6936H17.1169C17.1169 14.6936 17.1307 12.0794 17.1307 12.1206Z"
      fill="#3E737C"
    />
    <path
      d="M17.576 12.5658H19.8706V14.2347H17.576C17.576 14.2347 17.576 12.5366 17.576 12.5658Z"
      fill="#A7D0D7"
    />
    <path
      d="M17.0895 15.9156H20.2743V18.3494H17.0895C17.0895 18.3494 17.0689 15.938 17.0895 15.9156Z"
      fill="#3E737C"
    />
    <path
      d="M17.5896 16.3608V17.863H19.7724V16.347C19.7724 16.347 17.569 16.3401 17.5896 16.3608Z"
      fill="#A7D0D7"
    />
    <path
      d="M8.60401 21.328L8.60229 14.6661H13.8445V21.328C13.8445 21.328 8.61776 21.328 8.60401 21.328Z"
      fill="#3E737C"
    />
    <path
      d="M13.2242 16.0256V15.1491C13.2242 15.1491 9.23494 15.1491 9.25041 15.1491V16.0256H13.2242Z"
      fill="#A7D0D7"
    />
    <path
      d="M13.2241 16.4639H9.25037V18.7447H13.2241V16.4639Z"
      fill="#A7D0D7"
    />
    <path
      d="M13.224 19.2139H9.25024V20.4067H13.224V19.2139Z"
      fill="#A7D0D7"
    />
    <path
      d="M11.0481 16.268V20.7556H11.5018V16.2216C11.5018 16.2216 11.079 16.268 11.0481 16.268Z"
      fill="#3E737C"
    />
    <path
      d="M11.0791 6.88531C9.29679 6.90078 8.10226 8.22938 8.19335 9.93781C8.28101 11.5981 9.59929 12.6397 11.1238 12.5967C12.7257 12.552 13.8738 11.2664 13.9185 9.74187C13.9632 8.21734 12.7257 6.87156 11.0791 6.88531Z"
      fill="#3E737C"
    />
    <path
      d="M11.0344 7.39922C9.58376 7.39922 8.6161 8.50265 8.67797 9.83125C8.73641 11.1134 9.59922 12.0828 11.0808 12.0828C12.4403 12.0828 13.3341 10.9656 13.3616 9.81578C13.3908 8.56109 12.4541 7.39922 11.0344 7.39922Z"
      fill="white"
    />
    <path
      d="M10.6116 9.87593C10.6116 9.87593 9.76941 10.5841 9.723 10.6666C9.6766 10.7491 9.67832 10.8848 9.79004 10.9759C9.90347 11.067 10.0152 11.0137 10.0839 10.9605C10.151 10.9072 11.0396 10.1784 11.0396 10.1784C11.0396 10.1784 11.3266 10.1733 11.3936 9.83296C11.4469 9.5614 11.251 9.43421 11.251 9.43421C11.251 9.43421 11.22 7.80827 11.2063 7.68796C11.1943 7.59858 11.1014 7.51437 11.0189 7.52296C10.9364 7.52983 10.8539 7.57624 10.8453 7.7103C10.8368 7.84437 10.8282 9.40155 10.8282 9.40155C10.8282 9.40155 10.7078 9.44624 10.6408 9.57515C10.5738 9.70233 10.6116 9.87593 10.6116 9.87593Z"
      fill="#2F2F2F"
    />
  </svg>
);

export default EmSchoolIcon;
